import React from "react";
import { FC } from "react";
import { IProduct } from "../../types";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

interface CartTotalBadgeProps {
  cart: IProduct[];
  open: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: "absolute",
    right: 0,
    bottom: 0,
    color: theme.palette.primary.dark,
    transform: "translateY(85%)",
  },
}));

const CartTotalBadge: FC<CartTotalBadgeProps> = ({ cart, open, ...props }) => {
  const classes = useStyles();
  if (!open) return null;

  return (
    <Paper className={classes.root}>
      <Typography noWrap>
        Total: ${cart.reduce((total, item) => total + item.price, 0)}
      </Typography>
    </Paper>
  );
};

export default React.memo(CartTotalBadge);
